import { Text as WalrusText } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';

const Text = styled(WalrusText)`
  color: ${vars.grey4};
  margin-top: 0;
`;

export default Text;
